<template>
  <label
    class="flex items-start font-bold text-base"
    :class="[
      isDisabled ? 'pointer-events-none text-charcoal-500' : ''
    ]"
    @click="handleUpdateValue"
  >
    <input :id="id" type="radio" :required="isRequired" :disabled="isDisabled" class="w-4 h-4 shrink-0" :checked="modelValue == value" :name="name" />

    <span class="ml-3 text-left -mt-1" v-if="label || $slots.default">
      {{ label }}
      <slot />
    </span>
  </label>
</template>

<script lang="ts" setup>
const props = withDefaults(defineProps<{
  id?: string
  modelValue: boolean | Date | string | null | Number
  value: boolean | Date | string | null | Number
  name: string
  isDisabled?: boolean
  isRequired?: boolean
  label?: string
}>(), {
  isDisabled: false,
  isRequired: false,
  label: ''
})

const emit = defineEmits([ 'update:modelValue' ])

const handleUpdateValue = () => {
  emit('update:modelValue', props.value)
}
</script>
